import { Layout } from '@/components/Layout/Layout.js';
import { FONT_FAMILY_VARIANTS } from '@/components/Typography/constants.js';
import { Heading } from '@/components/Typography/Heading.js';
import { styled } from '@/stitches/stitches.config.js';

export const HeroGrid = styled(Layout.Grid, {
  '@bp4': {
    gridRowGap: 0,
    marginBottom: '$34',
  },
});

export const AvatarContainer = styled('div', {
  '@bp4': {
    marginBottom: '$50',
  },
  justifySelf: 'end',
});

export const Headline = styled(Heading, {
  '@bp0': {
    fontSize: '$28',
  },
  '@bp2': {
    fontSize: '$48',
  },
  '@bp4': {
    fontSize: '$64',
  },
  variants: {
    fontFamily: {
      ...FONT_FAMILY_VARIANTS,
      generalSans: {
        fontWeight: '$semiBold',
      },
      panchang: {
        '@bp0': {
          fontSize: '$20',
        },
        '@bp2': {
          fontSize: '$32',
        },
        '@bp4': {
          fontSize: '$40',
        },
      },
      switzer: {
        fontWeight: '$medium',
      },
      syne: {
        fontWeight: '$medium',
      },
      zodiak: {
        fontWeight: '$regular',
      },
    },
    scaleTextDown: {
      true: {
        '@bp4': {
          fontSize: '$40',
        },
      },
    },
  },
});

export const Bio = styled('div', {
  '@bp0': {
    fontSize: '$16',
  },
  '@bp2': {
    fontSize: '$24',
  },
  fontFamily: '$body',
  fontWeight: 400,
  lineHeight: '$140',
  variants: {
    scaleTextDown: {
      true: {
        '@bp2': {
          fontSize: '$16',
        },
      },
    },
  },
  whiteSpace: 'break-word',
});

export const ButtonContainer = styled('div', {
  '@bp0': {
    flexDirection: 'column',
  },
  '@bp1': {
    flexDirection: 'row',
  },
  '@bp4': {
    margin: '0 0 0 0 !important',
  },
  display: 'flex',
  justifyContent: 'flex-start',
  margin: '0 0 $30 0',
});

export const LocationContainer = styled('div', {
  '& > svg': {
    flexShrink: 0,
    height: '1em',
    width: '1em',
  },
  alignItems: 'center',
  display: 'flex',
  gap: '$12',
  span: {
    fontSize: '$14',
    letterSpacing: '$1_5',
    textTransform: 'uppercase',
  },
});

export const MobileBadgeContainer = styled('div', {
  '&:empty': {
    display: 'none',
  },
  '@bp0': {
    gap: '$8',
  },
  '@bp1': {
    gap: '$16',
  },
  display: 'inline-flex',
  justifyContent: 'center',
  marginTop: '$24',
});
